
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import {UserConfigService} from "@/services/user-config-service";
import Vue from "vue";
import {IBreadCrumb, ISelectItem} from "winfakt-vue-components";
import {AuthService} from "../../../services/auth-service";
import {MODULE} from "../../../config/modules";
import {DossierConfigService} from "../../../services/dossier-config-service";
import AppSelectVat from "@/components/SelectVat.vue";
import VueI18n from "vue-i18n";
import {SaleService} from "@/services/sale-service";
import {DossierService} from "@/services/dossier-service";
import {Dossier} from "@/models/dossier/dossier";
import {DataSourcesConfig} from "@/models/dossier-configs/data-sources";
import AppMissingModule from "@/components/common/MissingModule.vue";
import AppVatRegimeOrder from "@/components/settings-sales/VatRegimeOrder.vue";
import {getExtraFieldKeyNames} from "@/utils/models/extra-fields";
import AppSaleEditRowExtraInfoFieldsSettings from "@/components/settings-sales/SaleEditRowExtraInfoFieldsSettings.vue";
import AppSaleTypeMultiSelect from "@/components/sales/SaleTypeMultiSelect.vue";
import {OpenClientInfoModalAfterSelectOptions} from "@/models/user-configs/sale-settings";
import AppEditDefaultImportSaleRowDescriptionTemplate
	from "@/components/settings-sales/EditDefaultImportSaleRowDescriptionTemplate.vue";
import AppStockLocationSelect from "@/components/StockLocationSelect.vue";
import AppSaleEditButtonVisibility from "@/components/settings-sales/SaleEditButtonVisibility.vue";
import { v4 } from "uuid";

export default Vue.extend({
	data() {
		return {
			SaleSettings: UserConfigService.getSaleSettings(),
			pluginSettings: UserConfigService.getPluginSettings(),
			dossierSaleSettings: DossierConfigService.getSaleConfigs(),
			dataSourcesSettings: DossierConfigService.getDataSourcesConfig(),
			purchaseSettings: DossierConfigService.getPurchaseConfig(),
			sending: false,
			dataSourcesHasChanges: false,
			dataSourcesDisabled: true,
			path: [{
				to: "/settings/sales", value: this.$ct("sale")
			}, {value: this.$ct("common")}] as IBreadCrumb[],
			dossiers: [] as Dossier[],
			useForProductLastSoldSaleTypeIds: [] as number[],
			useForProductLastOrderedSaleTypeIds: [] as number[],
			defaultSaleEditQuickButtonVisibility: [] as string[],
			defaultSaleEditHamburgerButtonVisibility: [] as string[],
			uid: v4()
		};
	},
	computed: {
		openSearchBrowseOnScannerInputRadioName():string {
			return `${this.uid}-open-search-browse-on-scanner-input`;
		},
		hasUblModule(): boolean {
			return AuthService.hasModule(MODULE.ELECTRONISCHE_FACTURATIE);
		},
		hasLeeggoedModule(): boolean {
			return AuthService.hasModule(MODULE.DRANKENCENTRALE);
		},
		newSaleAutoFocusItems(): any[] {
			let d = Object.entries(this.$ct("new-sale-auto-focus") as any as VueI18n.TranslateResult[]);
			return d.map(s => {
				return {
					text: s[1],
					value: s[0]
				};
			});
		},
		dossierItems(): ISelectItem<number>[] {
			return this.dossiers.map(d => {
				return {
					text: d.name,
					value: d.id
				} as ISelectItem<number>;
			});
		},
		hasCrossDossierAccessModule(): boolean {
			return AuthService.hasModule(MODULE.CROSS_DOSSIER_ACCESS);
		},
		isOwner(): boolean {
			return AuthService.wfCompany.OwnerID == AuthService.wfUser.ID;
		},
		extraFieldNames(): ISelectItem<string>[] {
			let t = getExtraFieldKeyNames("Text");
			let r = t.map(d => {
				return {
					text: d,
					value: d
				} as ISelectItem<string>;
			});
			r.unshift({
				text: this.$ct("no-vies-check-extra-field").toString(),
				value: ""
			});
			return r;
		},
		openClientInfoModalItems():ISelectItem<OpenClientInfoModalAfterSelectOptions>[]{
			return [
				OpenClientInfoModalAfterSelectOptions.OFF,
				OpenClientInfoModalAfterSelectOptions.INFO,
				OpenClientInfoModalAfterSelectOptions.EXTRA_FIELDS
			].map((val)=>{
				return {
					text: this.$ct(`open-client-info-modal-option.${val}`),
					value: val,
				} as ISelectItem<OpenClientInfoModalAfterSelectOptions>;
			});
		},
		disabledSaleEditFields(): ISelectItem<string>[] {
			return Object.keys(this.$ct("components.sales.sale-edit-fields")).map(l => {
				return {
					text: this.$ct("components.sales.sale-edit-fields." + l),
					value: l
				} as ISelectItem<string>;
			});
		},
	},
	watch: {
		dataSourcesSettings: {
			deep: true,
			handler() {
				this.dataSourcesHasChanges = true;
			}
		}
	},
	methods: {
		async save() {
			if (this.sending) return;
			try {
				this.sending = true;
				this.SaleSettings = await UserConfigService.setSaleSettings(this.SaleSettings);
				this.pluginSettings = await UserConfigService.setPluginSettings(this.pluginSettings);
				this.purchaseSettings = await DossierConfigService.setPurchaseConfig(this.purchaseSettings);
				this.setLastOrderedAndSoldSettings();
				this.dossierSaleSettings = await DossierConfigService.setSaleConfigs(this.dossierSaleSettings);
				if (!this.dataSourcesDisabled) {
					if (this.dataSourcesHasChanges && this.hasCrossDossierAccessModule) {
						this.dataSourcesSettings = await DossierConfigService.setDataSourcesConfig(this.resetDataSourceValues(this.dataSourcesSettings));
					}
				}
				this.$router.back();
			} catch (err) {
			}
			this.sending = false;
		},
		setLastOrderedAndSoldSettings(){
			let keys = Object.keys(this.dossierSaleSettings.Configs);
			for (let key of keys) {
				let conf = this.dossierSaleSettings.Configs[key];
				let id = parseInt(key);
				if (Number.isNaN(id) || id == 0){
					continue;
				}
				conf.UseForProductLastOrdered = this.useForProductLastOrderedSaleTypeIds.indexOf(id) != -1;
				conf.UseForProductLastSold = this.useForProductLastSoldSaleTypeIds.indexOf(id) != -1;
			}
		},
		setDataSourceValues(conf: DataSourcesConfig): DataSourcesConfig {
			let c = new DataSourcesConfig(conf.getJSON());
			let currentDossierID = AuthService.wfDossier.id;
			if (c.ContactsDossierID == 0) {
				c.ContactsDossierID = currentDossierID;
			}
			if (c.ProductsDossierID == 0) {
				c.ProductsDossierID = currentDossierID;
			}
			return c;
		},
		resetDataSourceValues(conf: DataSourcesConfig): DataSourcesConfig {
			let c = new DataSourcesConfig(conf.getJSON());
			let currentDossierID = AuthService.wfDossier.id;
			if (c.ContactsDossierID == currentDossierID) {
				c.ContactsDossierID = 0;
			}
			if (c.ProductsDossierID == currentDossierID) {
				c.ProductsDossierID = 0;
			}
			return c;
		}
	},
	async created() {
		this.defaultSaleEditHamburgerButtonVisibility = await UserConfigService.getDefaultSaleEditHamburgerButtons();
		this.defaultSaleEditQuickButtonVisibility = await UserConfigService.getDefaultSaleEditQuickButtons();
		this.dataSourcesSettings = this.setDataSourceValues(DossierConfigService.getDataSourcesConfig());
		let keys = Object.keys(this.dossierSaleSettings.Configs);
		for (let key of keys) {
			let conf = this.dossierSaleSettings.Configs[key];
			let id = parseInt(key);
			if (Number.isNaN(id) || id == 0){
				continue;
			}
			if (conf.UseForProductLastOrdered) {
				this.useForProductLastOrderedSaleTypeIds.push(id);
			}
			if (conf.UseForProductLastSold){
				this.useForProductLastSoldSaleTypeIds.push(id);
			}
		}
		if (!this.isOwner) return;
		this.dossiers = await DossierService.getDossiers();
		if (this.dossiers.length == 1) {
			return;
		}
		this.dataSourcesDisabled = await SaleService.hasSales();
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppSelectVat,
		AppMissingModule,
		AppVatRegimeOrder,
		AppSaleEditRowExtraInfoFieldsSettings,
		AppSaleTypeMultiSelect,
		AppEditDefaultImportSaleRowDescriptionTemplate,
		AppStockLocationSelect,
		AppSaleEditButtonVisibility
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
